import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DataTablesModule } from 'angular-datatables';
import { LayoutModule } from './layout/layout.module';
import { MaterialModule } from './material.module';
import { HttpClientModule } from '@angular/common/http';
import { TokenComponent } from './token/token.component';
import { httpInterceptorProviders } from './token';
import { TokenGuard } from './layout/components/guards/token.guard';
import { MatIconModule } from '@angular/material/icon';
import { AdminSetariModule } from './components/administrativ/admin-setari/admin-setari.module';
import { SettingsModule } from './components/settings/settings.module';

@NgModule({
    declarations: [AppComponent, TokenComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        DataTablesModule,
        LayoutModule,
        MaterialModule,
        HttpClientModule,
        MatIconModule,
        AdminSetariModule,
        SettingsModule
    ],
    providers: [httpInterceptorProviders, TokenGuard],
    bootstrap: [AppComponent],
})
export class AppModule { }
